import {
  getSocialSharingProviders,
  getIsCommentsEnabled,
} from '../selectors/app-settings-selectors';
import { getIsMemberAreaInstalled } from '../store/communities-context/communities-context-selectors';
import { type AppState } from '../types';

const createPermissionFlags = (state: AppState) => ({
  isMemberAreaInstalled: getIsMemberAreaInstalled(state),
  isSocialSharingEnabled: Boolean(getSocialSharingProviders(state).length),
  isCommentsEnabled: getIsCommentsEnabled(state),
});

export default createPermissionFlags;
